import { Accordion } from '../../molecules/accordion/Accordion';
import { Heading } from '../../typography/heading/Heading';
import styles from './Footer.module.scss';
import './Footer.global.scss';
import { FooterColumn } from './FooterColumn';
import { FooterNewsletterForm } from './FooterNewletterForm';
import PropTypes from 'prop-types';
import React from 'react';

import FooterInfo from './FooterInfo';

import clsx from 'clsx';
import MediaImage from '@frontastic/catwalk/src/js/mediaImage';
import { getCurrentLocale } from '../../../utils/getCurrentLocale';

const Footer = ({
  columns,
  socialLinks = [],
  newsletterFormText = null,
  newsletterFormTitle = null,
  paymentMethods = null,
  copyright = null,
  loggedIn,
  isProduct,
  mobileLogo,
  desktopLogo,
  items,
}) => {
  const currentLocale = getCurrentLocale();

  const copyrightYear = new Date().getFullYear();

  return (
    <div
      className={clsx(styles.footerWrapper, {
        [styles.productFooter]: isProduct,
      })}
    >
      <FooterInfo items={items} />
      <div className={styles.footerInner}>
        <div className={styles.footer}>
          {desktopLogo?.media?.file && (
            <div className={clsx(styles.footerLogo, styles.footerLogoDesktop)}>
              <svg height={desktopLogo.media.height} width={desktopLogo.media.width}>
                <image xlinkHref={desktopLogo.media.file} src={desktopLogo.media.file} alt={desktopLogo.media.name} />
              </svg>
            </div>
          )}
          {mobileLogo && (
            <div className={clsx(styles.footerLogo, styles.footerLogoMobile)}>
              <MediaImage media={mobileLogo} />
            </div>
          )}
          <div className={clsx(styles.footerColumns, styles.footerColumnsMobile)}>
            <Accordion
              customClasses={{
                accordionWrapper: styles.accordionWrapper,
              }}
            >
              {columns &&
                Array.from(columns).map((column, index) => (
                  <Accordion.Section
                    customClasses={{
                      section: styles.section,
                    }}
                    key={index}
                    isOpen
                    title={column.title}
                    id={`section_${index}`}
                  >
                    <Accordion.Title
                      customClasses={{
                        title: styles.accordionTitle,
                      }}
                    >
                      <Heading
                        as="p"
                        textTransform="uppercase"
                        customClasses={{
                          common_p: styles.common_p,
                        }}
                      >
                        {column.title}
                      </Heading>
                    </Accordion.Title>
                    <Accordion.Panel>
                      <FooterColumn links={column.links} loggedIn={loggedIn} currentLocale={currentLocale} />
                    </Accordion.Panel>
                  </Accordion.Section>
                ))}
            </Accordion>
          </div>
          <div className={clsx(styles.footerColumns, styles.footerColumnsDesktop)}>
            {columns &&
              Array.from(columns).map((column, index) => (
                <FooterColumn
                  key={index}
                  title={column.title}
                  links={column.links}
                  loggedIn={loggedIn}
                  currentLocale={currentLocale}
                />
              ))}
          </div>
          <FooterNewsletterForm
            title={newsletterFormTitle}
            description={newsletterFormText}
            className={styles.footerNewsletter}
            socialLinks={socialLinks}
            loggedIn={loggedIn}
          />
        </div>
      </div>
      <div className={styles.copyright}>
        <div className={styles.copyrightInner}>
          <p className={styles.copyrightText}>
            <span>{copyrightYear}</span>
            &nbsp;
            <span>{copyright}</span>
          </p>
          <div
            className={styles.paymentIcons}
            style={{
              '--payment-count': paymentMethods && Array.from(paymentMethods)?.length,
            }}
          >
            {paymentMethods &&
              Array.from(paymentMethods).map(({ paymentLocale, paymentIcon, paymentIconName }, index) =>
                currentLocale === paymentLocale || paymentLocale === 'all' ? (
                  paymentIcon && paymentIcon.media ? (
                    <svg
                      key={index}
                      className={paymentIconName?.toLowerCase()}
                      height={paymentIcon.media.height}
                      width={paymentIcon.media.width}
                    >
                      <image xlinkHref={paymentIcon.media.file} src={paymentIcon.media.file} alt={paymentIconName} />
                    </svg>
                  ) : null
                ) : null,
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  columns: PropTypes.array.isRequired,
  socialLinks: PropTypes.array,
  newsletterFormText: PropTypes.string,
  newsletterFormTitle: PropTypes.string,
  paymentMethods: PropTypes.array,
  copyright: PropTypes.string,
};

export default Footer;
